import { LocalStorage } from 'quasar'

const initialState = () => ({
  access_token: LocalStorage.getItem('access_token') || '',
  gql_access_token: LocalStorage.getItem('gql_access_token') || '',
  refresh_token: '',
  gql_refresh_token: '',
  biometric_login_enabled: !!LocalStorage.getItem('biometric_login_enabled'),
  status: ''
})

export default initialState
